import xtend from 'xtend';
import request from 'model-fns/request';
import errors from 'model-fns/errors';
import S from 'pull-stream';
// import Event from '../../lib/event';
import _ from 'underscore';
import Store from 'pull-store';
import assocPath from 'ramda/src/assocPath';
import isURI from 'validate.io-uri';
import isEmail from 'validate.io-email-address';
import phone from 'telephone-stuff';
var isPhone = phone.validate;
var r = {
    apply: require('ramda/src/apply')
};
import queryString from '../../utils/QueryString';
import Request from '../lib/requests';
import Ev from '../../lib/event';
import history from '../../history';


function RokuModel () {
    return xtend(request(), errors(), {
        activeStep: 0,
        pendingEdits: {
        },
        isBrowsingImages: false,
        hasData: {},
        stepIsValid: {},
        success: false,
        billingConfirmation: false
    });
}

RokuModel.effects = function (api) {
    var effects = {
        saveJob: function (state, ev) {
            return Request('saveJob', api.ottJob.add.bind(api.ottJob, {
                ottChannelID: state.pendingEdits.ottChannelID,
                ottTargetType: 'roku',
                data: xtend(state.pendingEdits, {
                    ottTargetType: 'roku'
                })
            }));
        }
    };

    return r.apply(function mapToEffects (state, ev) {
        var fn = effects[Ev.type(ev)];
        if (!fn) return S.once(ev);
        return fn(state, Ev.data(ev));
    });
};

RokuModel.update = xtend(request.update, errors.update, {
    nextStep: function (state, ev) {
        return _.compose(
            _.partial(RokuModel.update.changeStep, _, state.activeStep + 1),
            RokuModel.update.setPendingEdits
        )(state, ev || {});
    },

    setPendingEdits: function (state, ev) {
        return assocPath(
            ['pendingEdits'],
            xtend(state.pendingEdits, ev),
            state
        );
    },

    prevStep: function (state, ev) {
        return RokuModel.update.changeStep(state, state.activeStep - 1);
    },

    changeStep: function (state, ev) {
        return xtend(state, {
            activeStep: ev
        });
    },

    browseImages: function (state, ev) {
        return xtend(state, {
            isBrowsingImages: ev
        });
    },

    closeImageModal: function (state, ev) {
        return xtend(state, {
            isBrowsingImages: false
        });
    },

    selectCategory: function (state, ev) {
        return xtend(state, {
            pendingEdits: xtend(state.pendingEdits, {
                channelCategory: ev
            })
        });
    },

    selectImage: function (state, ev) {
        var data = {};
        data[state.isBrowsingImages] = {
            assetID: ev.assetID
        };

        return RokuModel.update.closeImageModal(xtend(state, {
            pendingEdits: xtend(state.pendingEdits, data)
        }), null);
    },

    fieldChange: function (state, ev) {
        var newData = {};
        newData[ev.key] = ev.value;
        return xtend(state, {
            pendingEdits: xtend(state.pendingEdits, newData)
        });
    },

    phoneChange: function (state, ev) {
        return assocPath(
            ['pendingEdits', 'supportPhone'],
            phone.format(phone.parse(ev)),
            state
        );
    },

    changeText: function (state, ev) {
        return assocPath(['pendingEdits', ev.key], ev.value, state);
    },

    changeBackgroundColor: function (state, ev) {
        return assocPath(['pendingEdits', 'backgroundColor'], ev.hex, state);
    },

    saveJob: function (state, ev) {
        history.push('/manage/ott')
        return xtend(state, {
            success: true,
        });
    },

    confirmBilling: function (state, ev) {
        return xtend(state, {
            billingConfirmation: true
        });
    }
});

function validateLength (max, str) {
    str = str || '';
    return str.length && str.length <= max;
}

RokuModel.store = function () {
    var store = Store(function (state, ev) {
        const qsParams = queryString.parse(window.location.search);
        const channelID = qsParams.id;
        if (state.pendingEdits && !state.pendingEdits.ottChannelID && channelID) {
            state.pendingEdits.ottChannelID = channelID
        }
        return RokuModel.update[ev[0]](state, ev[1]);
    }, RokuModel());

    var stream = S(
        S.filter(Boolean),
        store(),

        S.map(function isValid (newState) {

            return xtend(newState, {
                support: {
                    isValid: {
                        phone: isPhone(
                            phone.parse(newState.pendingEdits.supportPhone)
                        ),
                        url: isURI(newState.pendingEdits.supportUrl),
                        email: isEmail(newState.pendingEdits.supportEmail)
                    }
                },

                stepIsValid: [
                    // channel store info
                    _.every([
                        newState.pendingEdits.channelName,
                        validateLength(300,
                            newState.pendingEdits.channelDescription),
                        validateLength(1500,
                            newState.pendingEdits.webDescription),
                        newState.pendingEdits.channelPoster,
                        newState.pendingEdits.channelCategory
                    ]),

                    // branding
                    _.every([
                        newState.pendingEdits.channelLogo,
                        newState.pendingEdits.splashScreen,
                        newState.pendingEdits.smallLogo,
                        newState.pendingEdits.backgroundImage
                    ]),

                    // support contact
                    _.every([
                        newState.pendingEdits.supportUrl,
                        isURI(newState.pendingEdits.supportUrl),

                        newState.pendingEdits.supportName,

                        newState.pendingEdits.supportPhone,
                        isPhone(phone.parse(
                            newState.pendingEdits.supportPhone || '')),

                        newState.pendingEdits.supportEmail,
                        isEmail(newState.pendingEdits.supportEmail)
                    ])
                ]
            });
        })
    );

    stream.state = store.state;
    return stream;
};

export default RokuModel;
